module.exports = __webpack_public_path__ + "img/momofin-go.8ea22fa6.png";